(function () {
  const drawer = document.querySelector('[data-options-drawer]');
  if (!drawer || drawer.dataset.ready === 'true') return;
  drawer.dataset.ready = 'true';

  const sectionId = drawer.dataset.section;
  const root = document.getElementById('MainProduct-' + sectionId);
  const productNode = root && root.querySelector('.productJson');
  if (!root || !productNode) return;

  let product;
  try {
    product = JSON.parse(productNode.textContent);
  } catch (error) {
    return;
  }

  const options = product.options || [];
  const variants = product.variants || [];
  const labelNode = drawer.querySelector('[data-drawer-option-labels]');
  let optionLabels = options.slice();
  if (labelNode) {
    try {
      const parsedLabels = JSON.parse(labelNode.textContent);
      if (parsedLabels.length) optionLabels = parsedLabels;
    } catch (error) {}
  }
  const openButton = root.querySelector('[data-open-options]');
  if (!options.length || variants.length < 2 || !openButton) return;

  function optionValue(variant, index) {
    if (variant.options && variant.options[index] != null) return variant.options[index];
    return variant['option' + (index + 1)];
  }

  const groups = drawer.querySelector('[data-drawer-groups]');
  const priceNode = drawer.querySelector('[data-drawer-price]');
  const compareNode = drawer.querySelector('[data-drawer-compare]');
  const submit = drawer.querySelector('[data-drawer-submit]');
  const stickyPrice = root.querySelector('[data-sticky-price]');
  const stickyCompare = root.querySelector('[data-sticky-compare]');
  const pagePrice = document.getElementById('price-' + sectionId);
  const selected = options.map(function () {
    return null;
  });
  let pagePriceText = stickyPrice ? stickyPrice.textContent.trim() : '';
  let pageCompareText = stickyCompare && !stickyCompare.hidden ? stickyCompare.textContent.trim() : '';

  function money(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      const format =
        (window.cartStrings && window.cartStrings.money_format) ||
        (window.themeGlobalVariables &&
          window.themeGlobalVariables.settings &&
          window.themeGlobalVariables.settings.money_format);
      return Shopify.formatMoney(cents, format);
    }
    return '';
  }

  function variantFor(choice) {
    return variants.find(function (variant) {
      return options.every(function (_, index) {
        return !choice[index] || optionValue(variant, index) === choice[index];
      });
    });
  }

  function exactVariant() {
    if (selected.some(function (value) { return !value; })) return null;
    return variants.find(function (variant) {
      return options.every(function (_, index) {
        return optionValue(variant, index) === selected[index];
      });
    });
  }

  function valueAvailable(index, value) {
    return variants.some(function (variant) {
      if (!variant.available || optionValue(variant, index) !== value) return false;
      return options.every(function (_, optionIndex) {
        return optionIndex === index || !selected[optionIndex] || optionValue(variant, optionIndex) === selected[optionIndex];
      });
    });
  }

  function setPriceLook(onSale) {
    priceNode.classList.toggle('primary-color', onSale);
    priceNode.classList.toggle('heading_weight', onSale);
    priceNode.classList.toggle('heading-style', !onSale);
    const regular = priceNode.closest('.price-regular');
    if (regular) regular.classList.toggle('primary-color', onSale);
  }

  function paintPrice(cents, compareCents) {
    const formatted = money(cents);
    const compare = compareCents && compareCents > cents ? money(compareCents) : '';
    if (formatted) priceNode.textContent = formatted;
    compareNode.textContent = compare;
    compareNode.hidden = !compare;
    setPriceLook(!!compare);
  }

  function syncFromPage() {
    if (!pagePrice) return;
    const current = pagePrice.querySelector('.price');
    const compare = pagePrice.querySelector('.compare-price');
    if (current) pagePriceText = current.textContent.trim();
    pageCompareText = compare ? compare.textContent.trim() : '';
    if (!drawer.classList.contains('is-open') || !exactVariant()) {
      if (stickyPrice && pagePriceText) stickyPrice.textContent = pagePriceText;
      if (stickyCompare) {
        stickyCompare.textContent = pageCompareText;
        stickyCompare.hidden = !pageCompareText;
      }
    }
  }

  function renderState() {
    selected.forEach(function (value, index) {
      if (value && !valueAvailable(index, value)) selected[index] = null;
    });
    const match = exactVariant();
    const clearButton = drawer.querySelector('[data-clear-options]');
    if (clearButton) clearButton.hidden = !selected.some(function (value) { return value; });
    groups.querySelectorAll('[data-drawer-selected]').forEach(function (node) {
      node.textContent = selected[Number(node.dataset.drawerSelected)] || '';
    });
    groups.querySelectorAll('[data-option-index]').forEach(function (button) {
      const index = Number(button.dataset.optionIndex);
      const value = button.dataset.value;
      const available = valueAvailable(index, value);
      button.classList.toggle('is-selected', selected[index] === value);
      button.classList.toggle('is-unavailable', !available);
    });

    if (!match) {
      priceNode.textContent = pagePriceText;
      compareNode.textContent = pageCompareText;
      compareNode.hidden = !pageCompareText;
      setPriceLook(!!pageCompareText);
      submit.disabled = true;
      submit.classList.remove('is-ready');
      setSubmitLabel(drawer.dataset.pendingLabel);
      return;
    }

    paintPrice(match.price, match.compare_at_price);
    if (stickyPrice) stickyPrice.textContent = priceNode.textContent;
    if (stickyCompare) {
      stickyCompare.textContent = compareNode.textContent;
      stickyCompare.hidden = compareNode.hidden;
    }
    submit.disabled = !match.available;
    submit.classList.toggle('is-ready', match.available);
    setSubmitLabel(match.available ? drawer.dataset.addLabel : drawer.dataset.soldLabel);
  }

  function setSubmitLabel(text) {
    const label = submit.querySelector('[data-drawer-submit-label]');
    if (label) label.textContent = text;
  }

  options.forEach(function (name, index) {
    const values = [];
    variants.forEach(function (variant) {
      const value = optionValue(variant, index);
      if (value && values.indexOf(value) === -1) values.push(value);
    });
    const group = document.createElement('div');
    group.className = 'options-drawer__group product-form__input relative flex flex-wrap mb-25 mx-0 p-0 border-0 gap-10';
    const label = document.createElement('div');
    label.className = 'form__label gap-10 w-full lh-normal flex align-center';
    const nameNode = document.createElement('span');
    nameNode.appendChild(document.createTextNode((optionLabels[index] || name) + ': '));
    const selectedValue = document.createElement('span');
    selectedValue.className = 'option_value heading-style capitalize swatch-selected-value';
    selectedValue.dataset.drawerSelected = String(index);
    nameNode.appendChild(selectedValue);
    label.appendChild(nameNode);
    const list = document.createElement('div');
    list.className = 'options-drawer__values flex flex-wrap gap-10 w-full';
    values.forEach(function (value) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'options-drawer__value product__item-option inline-flex align-center border rounded-3 subheading_weight btn-hover lh-normal px-20 py-10 transition relative';
      button.dataset.optionIndex = String(index);
      button.dataset.value = value;
      const text = document.createElement('span');
      text.className = 'relative z-2 uppercase-first-letter';
      text.textContent = value;
      button.appendChild(text);
      button.addEventListener('click', function () {
        if (button.classList.contains('is-unavailable')) return;
        selected[index] = selected[index] === value ? null : value;
        renderState();
      });
      list.appendChild(button);
    });
    group.appendChild(label);
    group.appendChild(list);
    groups.appendChild(group);
  });

  function openDrawer() {
    syncFromPage();
    const qtyInput = drawer.querySelector('[data-drawer-qty]');
    if (qtyInput) qtyInput.value = qtyInput.min || '1';
    drawer.classList.add('is-open');
    document.documentElement.classList.add('options-drawer-open');
    const close = drawer.querySelector('.options-drawer__close');
    if (close) close.focus();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('options-drawer-open');
  }

  function applyOnPage(variant) {
    const picker = root.querySelector('variant-radios-detail, variant-group-detail');
    if (!picker) return;
    const fieldsets = picker.querySelectorAll('fieldset');
    let lastInput = null;
    fieldsets.forEach(function (fieldset, index) {
      const value = optionValue(variant, index);
      const input = Array.from(fieldset.querySelectorAll('input[type="radio"]')).find(function (item) {
        return item.value === value;
      });
      if (!input) return;
      input.checked = true;
      lastInput = input;
    });
    if (lastInput) lastInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function addVariant(variant) {
    const form = document.getElementById('sticky-addcart-form-' + sectionId);
    if (!form) return;
    const productForm = form.closest('product-form');
    const idInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('[type="submit"]');
    if (!idInput) return;
    applyOnPage(variant);
    if (productForm) productForm.dataset.skipVariantSync = 'true';
    idInput.disabled = false;
    idInput.value = variant.id;
    if (addButton) addButton.disabled = false;
    const qtyInput = drawer.querySelector('[data-drawer-qty]');
    const formQty = form.querySelector('input[name="quantity"]');
    if (formQty && qtyInput) formQty.value = qtyInput.value || '1';
    submit.classList.add('loading');
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
    if (productForm) productForm.dataset.skipVariantSync = 'false';
    if (!addButton || !addButton.classList.contains('loading')) {
      submit.classList.remove('loading');
      closeDrawer();
      return;
    }
    const watch = new MutationObserver(function () {
      if (addButton.classList.contains('loading')) return;
      watch.disconnect();
      submit.classList.remove('loading');
      closeDrawer();
    });
    watch.observe(addButton, { attributes: true, attributeFilter: ['class'] });
  }

  openButton.addEventListener('click', openDrawer);
  drawer.querySelector('[data-clear-options]').addEventListener('click', function () {
    selected.fill(null);
    renderState();
  });
  drawer.querySelectorAll('[data-close-options]').forEach(function (button) {
    button.addEventListener('click', closeDrawer);
  });
  submit.addEventListener('click', function () {
    const match = exactVariant();
    if (!match || !match.available) return;
    addVariant(match);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
  });

  if (pagePrice) {
    new MutationObserver(syncFromPage).observe(pagePrice, {
      subtree: true,
      childList: true,
      characterData: true
    });
  }
  renderState();
})();
